import InsightsLogo, {COLORS} from './InsightsLogo'

export default InsightsLogo
export {InsightsLogo, COLORS}
